import { AnimatedComponent } from 'sane-ui'

class Card extends AnimatedComponent {
  buildTimelineIn () {
    this.timelineIn
      .to(this.$el, { duration: 0.6, autoAlpha: '1', ease: 'none' }, 0)
      .from(this.$el, { duration: 0.6, y: '15%', ease: 'power2.out' }, 0)
      .from(this.$el.find('.media-item'), { duration: 0.6, scale: '0.95', ease: 'power2.out' }, 0)
  }
}

export default Card



// WEBPACK FOOTER //
// ./scripts/components/animation/Card.js